<form *ngIf="model" name="editForm" role="form" (ngSubmit)="handleSubmit(SUBMIT)" autocomplete="off" class="p-2">
  <div class="modal-header">
    <h4 class="modal-title text-center">Votre destination</h4>

    <i aria-label="Close" (click)="handleClick(CLOSE)" class="close pull-right align-middle fas fa-times"> </i>
  </div>

  <div class="modal-body">
    <jhi-alert-error></jhi-alert-error>
    <div class="row">
      <div class="col-md-6">
        <jhi-bary-input-country
          [id]="fields['country']"
          displayField="NAME"
          [label]="'specialPlace.countryLabel' | translate"
          [control]="controls.country"
        ></jhi-bary-input-country>
      </div>
      <div class="col-md-6">
        <jhi-bary-input-text [id]="fields['inseeCode']" [label]="'specialPlace.inseeCode' | translate" [control]="controls.inseeCode"></jhi-bary-input-text>
      </div>
      <div class="col-md-6">
        <jhi-bary-input-text [id]="fields['zipCode']" [label]="'specialPlace.zipCode' | translate" [control]="controls.zipCode"></jhi-bary-input-text>
      </div>
      <div class="col-md-6">
        <jhi-bary-input-text [id]="fields['city']" [label]="'specialPlace.city' | translate" [control]="controls.city"></jhi-bary-input-text>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <jhi-bary-button
      class="mr-2 bary-btn shadow-none btn-outline-primary btn"
      data-dismiss="modal"
      type="button"
      (clickEvent)="handleClick(CANCEL)"
      [label]="'BTN.CANCEL' | translate"
    ></jhi-bary-button>

    <jhi-bary-button class="btn bary-btn btn-primary d-block" type="submit" [label]="'BTN.SAVE' | translate"></jhi-bary-button>
  </div>
</form>
